import React from 'react';
import { bool, node, shape } from 'prop-types';
import { HeaderContext, defaultHeaderContextValues } from './HeaderContext';

const HeaderProvider = ({
  children = null,
  featureSwitches = {
    isRecentlyViewedEnabled: false,
  }
}) => {

  const headerContext = {
    ...defaultHeaderContextValues(),
    featureSwitches: {
      ...featureSwitches,
    }
  };

  return (
    <HeaderContext.Provider value={headerContext}>
      {children}
    </HeaderContext.Provider>
  );
};

HeaderProvider.propTypes = {
  children: node,
  featureSwitches: shape({
    isRecentlyViewedEnabled: bool,
  })
};

HeaderProvider.displayName = 'HeaderProvider';

export { HeaderProvider };
